import { render, staticRenderFns } from "./AllWorkPermits.vue?vue&type=template&id=4f4990ef&scoped=true&"
import script from "./AllWorkPermits.vue?vue&type=script&lang=js&"
export * from "./AllWorkPermits.vue?vue&type=script&lang=js&"
import style0 from "styles/viewAll.scss?vue&type=style&index=0&id=4f4990ef&lang=scss&scoped=true&"
import style1 from "styles/dashboard/style.scss?vue&type=style&index=1&id=4f4990ef&lang=scss&scoped=true&"
import style2 from "styles/dashboard/datatable.scss?vue&type=style&index=2&id=4f4990ef&lang=scss&scoped=true&"
import style3 from "./AllWorkPermits.vue?vue&type=style&index=3&id=4f4990ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4990ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f4990ef')) {
      api.createRecord('4f4990ef', component.options)
    } else {
      api.reload('4f4990ef', component.options)
    }
    module.hot.accept("./AllWorkPermits.vue?vue&type=template&id=4f4990ef&scoped=true&", function () {
      api.rerender('4f4990ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/AllWorkPermits.vue"
export default component.exports